'use strict';

var _ = require('lodash');
var csvParser = require('parse-csv');
var SpecialEventsCsvService = function SpecialEventsCsvService($q, $filter, momentService, fileSaveService, specialEventsGridService, configurationService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getLabelForKey(key) {
    return KEYS_TO_LABELS[key];
  }
  var DATE_KEYS = {
    startDate: true,
    endDate: true
  };
  var KEYS_TO_LABELS = {
    market: 'Market',
    eventName: 'Event',
    eventType: 'Event Type',
    startDate: 'Start Date',
    endDate: 'End Date'
  };
  var LABELS_TO_KEYS = _.chain(KEYS_TO_LABELS).mapValues(_.toLower).invert().value();
  function formatAsCsvRow(stringArayToFormat) {
    var rowValues = _.chain(stringArayToFormat).map(function (value) {
      return '"' + value + '"';
    }).join(',').value();
    return rowValues + '\r\n';
  }
  function createCsvHeader() {
    var labels = _.map(['market', 'eventName', 'eventType', 'startDate', 'endDate'], getLabelForKey);
    return formatAsCsvRow(labels);
  }
  function createCsvRow(row, market) {
    var selectedMarket = _.isUndefined(row.market) ? market : row.market;
    return formatAsCsvRow([selectedMarket, row.eventName, row.eventType, rmMomentFormat(row.startDate, 'DATE_ISO'), rmMomentFormat(row.endDate, 'DATE_ISO')]);
  }
  function exportToCsv(data, calendarName, market) {
    var fileData = createCsvHeader();
    var filePrefix = calendarName ? calendarName + ' ' : '';
    fileData = _.reduce(data, function (result, row) {
      result += createCsvRow(row, market);
      return result;
    }, fileData);
    fileSaveService.createFile(fileData, 'text/csv', filePrefix + 'SpecialEvents.csv');
  }
  function correctKey(value, key) {
    return LABELS_TO_KEYS[key];
  }
  function correctValue(value, key) {
    if (DATE_KEYS[key]) {
      return momentService.of(value, momentService.FIELD.DEPARTURE_DATE);
    }
    return value;
  }
  function getEventsMap() {
    return _.reduce(configurationService.getEvents(), function (result, event) {
      result[event.name] = event.type;
      return result;
    }, {
      'UserExcluded': 'Excluded'
    });
  }
  function correctEntry(entry) {
    var correctedEntry = _.chain(entry).mapKeys(correctKey).mapValues(correctValue).value();
    var eventsMap = getEventsMap();
    correctedEntry.eventType = eventsMap[correctedEntry.eventName];
    correctedEntry.isRowRemovable = true;
    correctedEntry.isRowEditable = !specialEventsGridService.isUserExclusionEvent(correctedEntry);
    return correctedEntry;
  }
  function correctRows(parsedData) {
    return _.chain(parsedData).map(correctEntry).value();
  }
  function validateMarkets(entry, validMarkets) {
    var splitMarkets = (entry.market || '').split(',');
    var isMarketValid = true;
    _.forEach(splitMarkets, function (market) {
      isMarketValid = isMarketValid && _.indexOf(validMarkets, market) !== -1;
    });
    return isMarketValid;
  }
  function validateEventName(entry, eventsMap) {
    return !!eventsMap[entry.eventName];
  }
  function validateEventDates(entry) {
    return entry.startDate.isBefore(entry.endDate) || entry.startDate.isSame(entry.endDate);
  }
  function validateRow(entry, validMarkets, eventsMap) {
    return validateMarkets(entry, validMarkets) && validateEventName(entry, eventsMap) && validateEventDates(entry);
  }
  function createImportResponse(importedData, validMarkets) {
    var eventsMap = getEventsMap();
    return _.reduce(importedData, function (response, row) {
      if (!validateRow(row, validMarkets, eventsMap)) {
        response.invalidRowsCount = response.invalidRowsCount + 1;
      } else {
        response.rows.push(row);
      }
      return response;
    }, {
      invalidRowsCount: 0,
      allRowsCount: importedData.length,
      rows: []
    });
  }
  function importFromCsv(fileData, validMarkets) {
    var importPromise = $q.defer();
    var fileReader = new FileReader();
    fileReader.onloadend = function () {
      var parsedData = csvParser.toJSON(fileReader.result, {
        headers: {
          included: true
        }
      });
      var importedData = correctRows(parsedData);
      var validationResponse = createImportResponse(importedData, validMarkets);
      importPromise.resolve(validationResponse);
    };
    fileReader.readAsText(fileData);
    return importPromise.promise;
  }
  return {
    exportToCsv: exportToCsv,
    importFromCsv: importFromCsv
  };
};
SpecialEventsCsvService.$inject = ['$q', '$filter', 'MomentService', 'FileSaveService', 'SpecialEventsGridService', 'ConfigurationService'];
module.exports = SpecialEventsCsvService;